<template>
  <div class="main-content">
    <div class="container">
      <community-join></community-join>
      <div class="row">
        <div class="col-12">
          <div class="heading mb-3 text-center">
            <h1>Community Documents</h1>
            <p>
              Here you can find documents and templates shared by all the
              Analyst Hub users.<br />
              Feel free to engage, comment, ask questions and add documents you
              like to your favourites.
            </p>
            <p>
              If you see something that could be perfect for your next project,
              be our guest and use one of these community documents as a
              starting point for your own craft.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="filter-bar filter-full">
            <div class="most-recent">
              <select
                class="form-control"
                @change="sortItem($event)"
                v-model="defaultSort"
              >
                <option v-for="option in options" :value="option.value" :key="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="search-box-right">
              <a href="javascript:;" class="search-box-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <g>
                    <g>
                      <path
                        fill="#6E7077"
                        d="M14.108 7.054a7.054 7.054 0 1 0-2.609 5.477l5.255 5.255a.73.73 0 0 0 1.032-1.032L12.531 11.5a7.025 7.025 0 0 0 1.577-4.445zm-12.649 0a5.595 5.595 0 1 1 11.19 0 5.595 5.595 0 0 1-11.19 0z"
                      />
                    </g>
                  </g></svg
              ></a>
              <div class="search-box">
                <a class="close-btn" v-if="search" @click="search = ''"></a>
                <input
                  type="text"
                  v-on:keyup.enter="updateQueryParams()"
                  v-model="search"
                  placeholder="Search..."
                  class="form-control select2-selection"
                />
                <button @click="updateQueryParams()"></button>
              </div>
            </div>
            <div class="filter-tabs">
              <ul>
                <li class="pointer" :class="{ active: defaultCategory === '' }">
                  <a
                    @click="
                      defaultCategory = '';
                      updateQueryParams();
                    "
                    ><span>All</span> {{ DocsData.count }}</a
                  >
                </li>
                <li
                  v-for="eachCount in DocsData.counts"
                  :key="eachCount.entity_group"
                  class="pointer"
                  :class="{
                    active: defaultCategory === eachCount.entity_group,
                    'text-uppercase': eachCount.entity_group === 'Dax',
                  }"
                >
                  <a
                    @click="
                      defaultCategory = eachCount.entity_group;
                      updateQueryParams();
                    "
                  >
                    <span v-if="eachCount.entity_group == 'Priorities Matrix'"
                      >Priorities</span
                    >
                    <span v-else>{{ eachCount.entity_group }}</span>
                    {{ eachCount.total }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
        class="row"
      >
        <div
          class="col-12 col-sm-6 col-md-3"
          v-for="(doc, $index) in DocsData.items"
          :key="$index"
        >
          <div class="grid-card-box">
            <a @click.prevent="goToApp(doc)">
              <div class="card-img">
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-if="doc.entity_name == 'Dax'"
                  style="background-image: url('/assets/img/dax.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'MCode'"
                  style="background-image: url('/assets/img/m-code.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'RAWCode'"
                  style="background-image: url('/assets/img/m-code.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'PythomCode'"
                  style="background-image: url('/assets/img/python-code-thumbnail.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'RCode'"
                  style="background-image: url('/assets/img/rcode-code-thumbnail.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Notepad'"
                  style="background-image: url('/assets/img/notepad-code-thumbnail.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Planner'"
                  style="
                    background-image: url('/assets/img/planner-thumbnail.png');
                    background-size: cover;
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Model Planner'"
                  style="
                    background-image: url('/assets/img/model_planner_thumbnail.png');
                    background-size: cover;
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Pipeline Planner'"
                  style="
                    background-image: url('/assets/img/pipeline_thumbnail.png');
                    background-size: cover;
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Priorities Matrix'"
                  style="
                    background-image: url('/assets/img/priority-thumbnail.png');
                    background-size: cover;
                  "
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="doc.entity_name == 'Playlist'"
                  style="background-image: url('/assets/img/playlist_play.svg')"
                ></a>
                <a
                  class="card-img-bg"
                  href="javascript:;"
                  v-else-if="
                    doc.entity_name == 'Portfolio' &&
                    doc.portfolio.pictures &&
                    Object.values(doc.portfolio.pictures).length
                  "
                  :style="{
                    backgroundImage:
                      'url(' +
                      Object.values(doc.portfolio.pictures)[0].path +
                      ')',
                  }"
                ></a>
                <VerticalColourPalette
                  v-else-if="
                    doc.colour_generator &&
                    doc.entity_group == 'Colour Theme' &&
                    doc.colour_generator.meta.colours
                  "
                  v-bind:count="doc.colour_generator.meta.coloursAmount"
                  v-bind:colours="doc.colour_generator.meta.colours"
                />
                <a
                  class="card-img-bg"
                  v-else
                  href="javascript:;"
                  style="background-image: url('/assets/img/colours-pic.jpg')"
                ></a>
                <div class="card-hover-box">
                  <a class="btn btn-sm-alternative-primary" href="javascript:;"
                    >Open Document</a
                  >
                  <div class="card-hover-btn">
                    <div class="card-btn copy-btn">
                      <a
                        href="#"
                        @click.prevent="
                          markClickedAction();
                          goToAppClone(doc);
                        "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                        >
                          <g>
                            <g>
                              <path
                                d="M6.23 14.308a2.538 2.538 0 0 1-2.538-2.539V5.077H2.407c-.565 0-1.022.457-1.022 1.022v8.44c0 1.147.93 2.076 2.077 2.076h8.44c.564 0 1.021-.457 1.021-1.022v-1.285zM6.23 0h9.232A2.538 2.538 0 0 1 18 2.538v9.231a2.538 2.538 0 0 1-2.538 2.539h-1.154v1.285A2.407 2.407 0 0 1 11.9 18h-8.44A3.462 3.462 0 0 1 0 14.538v-8.44a2.407 2.407 0 0 1 2.407-2.406h1.285V2.538A2.538 2.538 0 0 1 6.231 0zm0 1.385c-.636 0-1.153.516-1.153 1.153v9.231c0 .637.517 1.154 1.154 1.154h9.23c.638 0 1.154-.517 1.154-1.154V2.54c0-.638-.516-1.154-1.153-1.154z"
                              />
                            </g>
                          </g>
                        </svg>
                      </a>
                      <span
                        @click.prevent="
                          markClickedAction();
                          goToAppClone(doc);
                        "
                        >Copy</span
                      >
                    </div>
                    <div class="card-btn comment-btn pointer">
                      <a
                        @click.prevent="goToApp(doc, 'comments')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="24"
                          viewBox="0 0 19 19"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M5.784 9.773H12.3a.815.815 0 0 1 0 1.628H5.784a.815.815 0 0 1 0-1.628zM4.97 7.324c0-.446.365-.809.814-.809h2.443c.45 0 .815.363.815.81 0 .446-.365.809-.815.809H5.784a.812.812 0 0 1-.814-.81zM.084 8.958a8.958 8.958 0 1 1 4.645 7.854l-2.453 1.051c-1.352.58-2.718-.787-2.14-2.139l1.052-2.453A8.93 8.93 0 0 1 .084 8.958zm8.958-7.33a7.329 7.329 0 0 0-6.25 11.162l.221.359-1.379 3.217 3.217-1.379.36.22a7.329 7.329 0 0 0 11.16-6.25 7.329 7.329 0 0 0-7.33-7.328z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                      <span
                        onclick="return false"
                        @click="goToApp(doc, 'comments')"
                        >Comments</span
                      >
                    </div>
                    <like-button
                      :viewMode="'list-card'"
                      :docId="doc.id"
                      :status="doc.liked"
                      :total_likes="doc.likes_count"
                      :index="$index"
                    ></like-button>
                  </div>
                </div>
              </div>
            </a>
            <div class="card-info" v-if="doc.user">
              <div class="card-title">
                <h3>
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-if="doc.entity_name == 'Dax'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'MCode'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'RAWCode'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'PythonCode'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'RCode'"
                  />
                  <img
                    src="/assets/img/file-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Notepad'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Planner'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Model Planner'"
                  />
                  <img
                    src="/assets/img/planner-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                  />
                  <img
                    src="/assets/img/priorities-grid-icon.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Portfolio'"
                  />
                  <img
                    src="/assets/img/playlist_small_play.svg"
                    alt=""
                    v-else-if="doc.entity_name == 'Playlist'"
                  />
                  <img src="/assets/img/picture-icon.svg" alt="" v-else />
                  <router-link
                    v-if="doc.entity_name == 'Dax'"
                    :to="{
                      name: doc.entity_name,
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourFan'"
                    :to="{
                      name: 'Colours Fan',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourImage'"
                    :to="{
                      name: 'Image to Colours',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'ColourPalette'"
                    :to="{
                      name: 'Colours Palette',
                      query: { id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Planner'"
                    :to="{
                      name: 'Analytics Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Model Planner'"
                    :to="{
                      name: 'Data Model Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Pipeline Planner'"
                    :to="{
                      name: 'Data Pipeline Planner',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Priorities Matrix'"
                    :to="{
                      name: 'Priorities Matrix',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Portfolio'"
                    :to="{
                      name: 'Document View',
                      params: { document_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <router-link
                    v-else-if="doc.entity_name == 'Playlist'"
                    :to="{
                      name: 'Playlist',
                      params: { doc_id: doc.document_id },
                    }"
                    >{{ doc.name }}</router-link
                  >
                  <span v-else>{{ doc.name }}</span>
                </h3>
                <span class="btn shared-btn">SHARED</span>
              </div>
              <div class="card-profile">
                <div class="profile-author">
                  <span class="user-img">
                    <avatar
                      :src="'/storage/' + doc.user.photo"
                      :size="22"
                      :username="doc.user.name"
                      v-if="doc.user"
                    ></avatar>
                  </span>
                  <span>{{ doc.user.name }}</span>
                </div>
                <div class="social-stats">
                  <span
                    ><img
                      src="assets/img/bubble-icon.svg"
                      alt=""
                      width="18"
                    />{{ doc.comments_count }}</span
                  >
                  <span
                    :id="'card-like-icon' + $index"
                    :class="{ active: doc.liked }"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="-1 -2 20 19"
                      style="width: 18px"
                    >
                      <g>
                        <g>
                          <g>
                            <path
                              stroke="#000"
                              stroke-width="1.5"
                              fill="#fff"
                              d="M16.388 1.696c2.023 2.113 2.19 5.519.227 7.753-1.215 1.381-2.657 2.943-3.976 4.165-.658.61-1.303 1.15-1.886 1.544-.543.367-1.17.703-1.753.703-.584 0-1.21-.336-1.753-.703-.583-.394-1.228-.934-1.886-1.544C4.04 12.392 2.6 10.83 1.385 9.449c-1.964-2.234-1.796-5.64.227-7.753 1.999-2.086 5.18-2.27 7.386-.427 2.21-1.843 5.391-1.66 7.39.427z"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span class="m-0" :id="'likesCount' + $index">{{
                      doc.likes_count
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentHttpService from "../services/DocumentHttpService";
import Avatar from "vue-avatar";
import LikeButton from "./partials/LikeButton";
import ApiService from "../api/api.service";
import CommunityJoin from "../views/CommunityJoin";
import VerticalColourPalette from "./partials/VerticalColourPalette";

export default {
  name: "Community",
  components: {
    LikeButton,
    Avatar,
    CommunityJoin,
    VerticalColourPalette,
  },
  data: function () {
    return {
      DocsData: {
        items: [],
        count: 0,
        counts: {},
      },
      confirm: false,
      docId: null,
      busy: false,

      search: this.$route.query.query || "",
      defaultCategory: this.$route.query.category || "",
      defaultSort: this.$route.query.order_by || "created_at",
      options: [
        { text: "Most Recent", value: "created_at" },
        { text: "Most Comments", value: "comments" },
        { text: "Most Likes", value: "likes" },
      ],

      currentPPage: 1,
      lastPPage: 0,

      // work around
      clickedApp: false,
    };
  },
  mounted() {
    this.clickedApp = false;
    const titleEl = document.querySelector("head title");
    titleEl.textContent = "Analyst Hub by Enterprise DNA";

    this.init();
  },

  methods: {
    init() {
      this.docService = new DocumentHttpService();
      this.docService.getShared(this.$route.query).then(({ data }) => {
        this.DocsData.count = data.count;
        this.DocsData.counts = data.counts;

        // pagination data
        this.DocsData.items = data.data.data;
        this.currentPPage = data.data.current_page;
        this.lastPPage = data.data.last_page;
      });
    },

    setFilterType(val) {
      this.defaultCategory = val;
      this.updateQueryParams();
    },

    sortItem($event) {
      this.defaultSort = $event.target.value;
      this.updateQueryParams();
    },

    updateQueryParams() {
      let category = {};
      let order_by = {};
      let searchQuery = {};

      if (this.search) {
        searchQuery = { query: this.search };
      }
      if (this.defaultCategory) {
        category = { category: this.defaultCategory };
      }
      if (this.defaultSort) {
        order_by = { order_by: this.defaultSort };
      }
      this.$router.push({
        query: { ...category, ...order_by, ...searchQuery },
      });

      this.init();
    },

    loadMore: function () {
      this.busy = true;
      if (this.currentPPage == this.lastPPage) {
        return;
      }
      setTimeout(() => {
        let currentParams = this.$route.query;
        // console.log(this.currentPPage);
        let pageParams = { page: this.currentPPage + 1 };
        let params = { ...currentParams, ...pageParams };
        this.docService.getShared(params).then(({ data }) => {
          this.currentPPage = data.data.current_page;
          this.lastPPage = data.data.last_page;
          for (let i = 0; i < data.data.data.length; i++) {
            this.DocsData.items.push(data.data.data[i]);
          }
        });
        this.busy = false;
      }, 1000);
    },

    markLiked($event) {
      this.busy = true;
      let newStatus;

      if ($event) {
        newStatus = $event.target.checked;
      } else {
        newStatus = !this.likeStatus;
      }
      // already marked
      let likeData = {
        document_id: this.docId,
        status: newStatus,
      };
      ApiService.setHeader();
      ApiService.post("/api/likes", likeData)
        .then(({ data }) => {
          this.likeStatus = data.data;
          if (this.likeStatus) {
            this.totalLikes++;
          } else {
            this.totalLikes--;
          }
          this.busy = false;
        })
        .catch((res) => {
          console.log(res);
          this.busy = false;
        });
    },

    cloneLink() {},
    commentLink() {},

    goToApp(doc, hash) {
      if (!this.clickedApp) {
        let to = {};
        if (doc.entity_name == "Dax") {
          to = { name: "Dax", query: { id: doc.document_id } };
        } else if (doc.entity_name == "MCode") {
          to = { name: "M Code", query: { id: doc.document_id } };
        } else if (doc.entity_name == "RAWCode") {
          to = { name: "RAW Code", query: { id: doc.document_id } };
        }else if (doc.entity_name == "RCode") {
          to = { name: "RCode", query: { id: doc.document_id } };
        } else if (doc.entity_name == "PythonCode") {
          to = { name: "PythonCode", query: { id: doc.document_id } };
        } else if (doc.entity_name == "Notepad") {
          to = { name: "Notepad", query: { id: doc.document_id } };
        }  else if (doc.entity_name == "ColourFan") {
          to = { name: "Colours Fan", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourImage") {
          to = { name: "Image to Colours", query: { id: doc.document_id } };
        } else if (doc.entity_name == "ColourPalette") {
          to = { name: "Colours Palette", query: { id: doc.document_id } };
        } else if (doc.entity_name == "Planner") {
          to = {
            name: "Analytics Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Model Planner") {
          to = {
            name: "Data Model Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Pipeline Planner") {
          to = {
            name: "Data Pipeline Planner",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Priorities Matrix") {
          to = {
            name: "Priorities Matrix",
            params: { doc_id: doc.document_id },
          };
        } else if (doc.entity_name == "Playlist") {
          to = { name: "Playlist", params: { doc_id: doc.document_id } };
        } else if (doc.entity_name == "Portfolio") {
          to = {
            name: "Document View",
            params: { document_id: doc.document_id },
          };
        }
        if (hash) {
          to.hash = "#comments";
        }
        this.clickedApp = true;
        this.$router.push(to);
        return null;
      }
    },

    goToAppClone(doc) {
      let to = {};
      if (doc.entity_name == "Dax") {
        to = { name: "Dax", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "MCode") {
        to = { name: "M Code", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "RAWCode") {
        to = { name: "RAW Code", query: { id: doc.document_id, clone: true } };
      }else if (doc.entity_name == "RCode") {
        to = { name: "RCode", query: { id: doc.document_id, clone: true } };
      }else if (doc.entity_name == "PythonCode") {
        to = { name: "PythonCode", query: { id: doc.document_id, clone: true } };
      }else if (doc.entity_name == "Notepad") {
        to = { name: "Notepad", query: { id: doc.document_id, clone: true } };
      } else if (doc.entity_name == "ColourFan") {
        to = {
          name: "Colours Fan",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "ColourImage") {
        to = {
          name: "Image to Colours",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "ColourPalette") {
        to = {
          name: "Colours Palette",
          query: { id: doc.document_id, clone: true },
        };
      } else if (doc.entity_name == "Planner") {
        to = {
          name: "Analytics Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Model Planner") {
        to = {
          name: "Data Model Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Pipeline Planner") {
        to = {
          name: "Data Pipeline Planner",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Priorities Matrix") {
        to = {
          name: "Priorities Matrix",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Playlist") {
        to = {
          name: "Playlist",
          params: { doc_id: doc.document_id },
          query: { clone: true },
        };
      } else if (doc.entity_name == "Portfolio") {
        to = {
          name: "Document View",
          params: { document_id: doc.document_id },
          query: { clone: true },
        };
      }
      this.$router.push(to);
    },

    markClickedAction() {
      this.clickedApp = true;
      // reverting back
      setTimeout(() => {
        this.clickedApp = false;
      }, 300);
    },
  },
};
</script>

<style scoped>
.filter-full .filter-tabs ul {
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 1850px) {
  .filter-bar {
    flex-wrap: wrap;
  }
  .most-recent,
  .search-box-right {
    order: 0 !important;
    flex: 0 0 50%;
    max-width: 50%;
    margin-left: 0px;
  }
  .most-recent {
    padding-right: 20px;
  }
  .most-recent select.form-control,
  .search-box-right .search-box .form-control {
    width: 100%;
  }
  .filter-full .filter-tabs {
    width: 100%;
    margin-top: 0;
  }
}
@media (max-width: 575px) {
  .most-recent,
  .search-box-right {
    order: 0 !important;
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0px;
  }
  .most-recent {
    margin-bottom: 10px;
  }
}
</style>
